/* @flow */
import cx from 'classnames';
import React from 'react';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';

import Badge from 'components/Badge.jsx';
import Image from 'components/Image.jsx';
import GroupLink from 'groups/components/GroupLink.jsx';
import Group from 'entities/Group';

import UnreadStore from 'stores/UnreadStore';

import ux from 'styles/UX.css';
import styles from './styles/GroupOrgList-GroupItem.css';

class GroupItem extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group).isRequired,
  };

  state = {
    unreadCount: 0,
  };

  static getStores() {
    return [UnreadStore];
  }

  static calculateState(state, props) {
    const { group } = props;
    return {
      unreadCount: UnreadStore.getUnreadCount(group.getUuid()),
    };
  }

  hasUnreads() {
    return CurrentUser.inExpVariant('CLASS_BADGES') && this.state.unreadCount > 0;
  }

  renderBadge() {
    return (
      this.hasUnreads() &&
      <Badge
        className={styles.badge}
        count={this.state.unreadCount}
        color="brand"
        size="large"
        shape="square"
      />
    );
  }

  render() {
    const { group } = this.props;

    return (
      <li className={styles.this}>
        <GroupLink
          className={
            cx('GroupOrgList-item-link', ux.highlightLink, {
              [styles.withUnreads]: this.hasUnreads(),
            })
          }
          group={group}
          color="inherit"
          placement="right"
          alignment="top">
          <div className={styles.container}>
            <Image src={group.getAvatarUrl()} width={24} className={styles.avatar} />
            <div className={styles.name}>
              {group.getName()}
            </div>
            {this.renderBadge()}
          </div>
        </GroupLink>
      </li>
    );
  }
}

export default Container.create(GroupItem, { withProps: true, pure: false });



// WEBPACK FOOTER //
// ./src/groups/components/GroupOrgList-GroupItem.jsx